import React from 'react';
import PropTypes from 'prop-types';

import PopupWindowLink, { windowShape } from './PopupWindowLink';

const LoginLink = (props) => <PopupWindowLink {...props} />;

LoginLink.propTypes = {
  href: PropTypes.string,
  window: windowShape,
};

LoginLink.defaultProps = {
  href: '/auth/login/patient/?next=%2Fauth%2Fclose%2F',
  window: {
    name: 'login_popup',
    width: 650,
    height: 650,
    center: true,
  },
};

export default LoginLink;
